module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idCFClrPan",
    staticStyle: {
      "position": "absolute",
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "0px solid red",
      "width": "100%"
    }
  }, [_c('div', {
    ref: "idClrEle",
    staticStyle: {
      "float": "left",
      "margin-left": "16px",
      "width": "100px",
      "height": "28px",
      "border": "1px solid #bbbbbb"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "16px",
      "height": "24px",
      "line-height": "30px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('input', {
    ref: "idCurClr",
    staticStyle: {
      "width": "86px",
      "height": "24px",
      "font-family": "宋体",
      "font-size": "20px"
    },
    attrs: {
      "type": "text",
      "maxlength": "6"
    },
    on: {
      "change": _vm.onValueChange
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "clrMap",
    staticStyle: {
      "margin-right": "2px",
      "margin-top": "20px"
    },
    attrs: {
      "src": "/static/images/colormap.png"
    },
    on: {
      "mousedown": _vm.onMouseDown
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "70px",
      "margin-top": "20px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onWinCan
    }
  }, [_vm._v(_vm._s(_vm.txt1))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "70px",
      "margin-top": "20px",
      "margin-right": "10px",
      "float": "right"
    },
    on: {
      "click": _vm.onWinOk
    }
  }, [_vm._v(_vm._s(_vm.txt2))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-747f341a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/cf/cfcolor.vue
// module id = 797
// module chunks = 1